import {
  SIGN_IN,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILURE,
  SIGN_OUT,
} from "../../actions";
import { SESSION_ACCESS_KEY } from "../../utils/constants";

export const signIn =
  ({ username, password }) =>
  async (dispatch, _, { api, storage }) => {
    dispatch({ type: SIGN_IN });

    try {
      const response = await api.signIn(username, password);
      if (response.status !== 200) {
        throw new Error("Invalid credentials");
      }

      const { access_token: token } = await response.json();
      storage.setItem(SESSION_ACCESS_KEY, token);

      dispatch({ type: SIGN_IN_SUCCESS, payload: token });
      return token;
    } catch (error) {
      dispatch({ type: SIGN_IN_FAILURE, payload: error.message });
      // throw error;
      return undefined;
    }
  };

export const signInReset = () => ({ type: SIGN_OUT });

export const signOut =
  () =>
  (dispatch, _, { storage }) => {
    storage.removeItem(SESSION_ACCESS_KEY);
    dispatch({ type: SIGN_OUT });
  };
